import SpaceSizes from '../../../theme/foundations/spacing/SpaceSizes';

export const listContainertStyled = {
  marginTop: SpaceSizes.smPlus,
  '.MuiTypography-root': {
    marginBottom: SpaceSizes.sm - SpaceSizes.xs,
  },
};
